/**
 * Normalize strings (especially city names) into URL-safe slugs.
 * Converts Turkish characters, trims whitespace, and collapses separators.
 *
 * @param {string} value
 * @returns {string}
 */
export function slugify(value = "") {
  if (!value || typeof value !== "string") return "";

  return value
    .toLowerCase()
    .trim()
    .replace(/ş/g, "s")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c")
    .replace(/ı/g, "i")
    .replace(/İ/g, "i")
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

export default slugify;

